import axios from "axios";

import { Environment } from "./environment";
import getCookie from "./getCookie";

export class UserModelService {
  static get getUser() {
    return new UserModelService(JSON.parse(getCookie(Environment.cookie)));
  }

  isLogin = async () => {
    const url = Environment.profileApi + "/me";
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getCookie(Environment.token)}`,
      },
    };
    return await axios.get(url, config).then(response => response.data);
  };

  logout() {
    this.setToken(false);
  }

  setToken(token) {
    return new Promise(resolve => {
      document.cookie = Environment.token + "=" + token + ";path=/;domain=" + Environment.cookieDomain;

      resolve(true);
    });
  }
}
